import { HttpClient, HttpMethod, HttpStatusCode } from '@hub-la/fe-core-http-client'
import { inject } from 'inversify'
import { WhiteList } from '../domain/dtos/whitelist'
import { GeneralError } from '../domain/errors/general'
import { Envs } from '../envs'

export class GetWhitelist {
  public constructor(
    @inject(HttpClient)
    private readonly httpClient: HttpClient,
  ) {}

  public async execute(groupId: string): Promise<WhiteList[]> {
    const response = await this.httpClient.request({
      method: HttpMethod.POST,
      url: `${Envs.FUNCTIONS_URL}/group/getWhitelist/pt`,
      body: { data: { groupId } },
    })

    if (response.statusCode === HttpStatusCode.OK || response.statusCode === HttpStatusCode.CREATED) {
      return response.data.result
    }

    throw new GeneralError()
  }
}
